import { useContext } from 'react';
import { SourcePageTrackerContext } from '@/context/sourcePageTracker/sourcePageTrackerProvider';

export default function useSourcePageTracker() {
    const { sourcePageData } = useContext(SourcePageTrackerContext);

    return { sourcePageData };
}
